var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 14.4183 5.58171 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58171 14.4183 2 10 2C5.58171 2 2 5.58171 2 10ZM9.596 13.8326C9.48887 13.7254 9.42869 13.5801 9.42869 13.4286C9.42869 13.2771 9.48887 13.1317 9.596 13.0246L12.0491 10.5714H6.57143C6.41988 10.5714 6.27453 10.5112 6.16737 10.4041C6.0602 10.2969 6 10.1516 6 10C6 9.84845 6.0602 9.7031 6.16737 9.59594C6.27453 9.48878 6.41988 9.42857 6.57143 9.42857H12.0491L9.596 6.97543C9.49191 6.86766 9.43431 6.72331 9.43561 6.57349C9.43692 6.42366 9.49701 6.28034 9.60296 6.17439C9.70891 6.06844 9.85223 6.00835 10.0021 6.00704C10.1519 6.00574 10.2962 6.06334 10.404 6.16743L13.8326 9.596C13.9397 9.70316 13.9999 9.84848 13.9999 10C13.9999 10.1515 13.9397 10.2968 13.8326 10.404L10.404 13.8326C10.2968 13.9397 10.1515 13.9999 10 13.9999C9.84848 13.9999 9.70316 13.9397 9.596 13.8326Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.9ad2eafe8b1cac322cfa6fe00fd6c4df.svg";
export { ForwardRef as ReactComponent };